export default __webpack_public_path__ + "static/media/Weather.d563bc2e.png";